import { Choice } from "./model";

export function checkFilledCategories(
  choices: Choice[]
): { refinedSelectedChoices: Choice[]; filledCategories: string[] } {
  const total = {};
  const included = {};
  const excluded = {};
  // keep only selected options (include or exclude)
  const selectedChoices = choices.filter(({ status }) => status !== "none");
  // initialize total/included/excluded objects with options' categories set to 0
  const categories = [...new Set(choices.map(({ category }) => category))];
  categories.forEach((k) => {
    total[k] = 0;
    included[k] = 0;
    excluded[k] = 0;
  });
  // count include/exclude occurences in options and update relevant objects.
  choices.forEach(({ category }) => total[category]++);
  selectedChoices.forEach(({ category, status }) =>
    status === "exclude" ? excluded[category]++ : included[category]++
  );
  // keep categories which have all of their sub-options either included or excluded...
  const filledCategories = Object.keys(total)
    .map((category) =>
      total[category] === included[category] ||
      total[category] === excluded[category]
        ? category
        : null
    )
    .filter((c) => c);

  const refinedSelectedChoices = selectedChoices; // Temporarily bypass category grouping

  return {
    refinedSelectedChoices,
    filledCategories,
  };
}

export const customText = (value, data) => ({
  id: value || data.id,
  label: value || data.label,
  status: "include",
});
